const CHROME_NAVIGATION_TRAIL_PATHS = new Set(["/", "/sign-in", "/floor", "/tablet-pin", "/access-needed"]);

/** Keep in sync with MODULE_HOME_LABELS in breadcrumbRouteLabels.ts */
export const MODULE_HOME_NAVIGATION_TRAIL_PATHS = new Set([
  "/erp",
  "/mrp",
  "/bom",
  "/admin",
  "/clamp-qc",
  "/manufacturing",
  "/manufacturing-management",
  "/documents",
  "/wiki",
  "/shipping",
  "/accounting",
  "/quality",
  "/inside-sales",
  "/art-and-labels",
  "/printing",
]);

/** Module landing pages and top-level station queues — no breadcrumb trail on these routes. */
export const STATION_HOME_NAVIGATION_TRAIL_PATHS = new Set([
  "/shipping/receive",
  "/shipping/arrivals",
  "/shipping/holding",
  "/shipping/to-stock",
  "/shipping/outbound",
  "/shipping/pre-pack",
  "/shipping/receive/discrepancies",
  "/shipping/shipment-details",
  "/shipping/gosi-details",
  "/shipping/paperwork",
  "/shipping/settings",
]);

export function normalizeNavigationTrailPathname(pathname: string): string {
  return pathname.length > 1 && pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
}

export function isChromeNavigationTrailPath(pathname: string): boolean {
  return CHROME_NAVIGATION_TRAIL_PATHS.has(normalizeNavigationTrailPathname(pathname));
}

export function isModuleHomeNavigationPath(pathname: string): boolean {
  return MODULE_HOME_NAVIGATION_TRAIL_PATHS.has(normalizeNavigationTrailPathname(pathname));
}

export function isNavigationTrailRootPath(pathname: string): boolean {
  const normalized = normalizeNavigationTrailPathname(pathname);
  return (
    isChromeNavigationTrailPath(normalized)
    || MODULE_HOME_NAVIGATION_TRAIL_PATHS.has(normalized)
    || STATION_HOME_NAVIGATION_TRAIL_PATHS.has(normalized)
  );
}
